export const MAX_PAGINATION_SIZE = 1000;
export const MAX_SQL_DATE =  new Date('9999-12-31');
export const MIN_SQL_DATE =  new Date('1753-01-01');
export const MAX_PATIENT_BATCH = 100;
export const FACILITY_ADMIN = 'ADMIN';

export const BURGER_SVG_ICON = 'assets/images/burger.svg';
